@if (vm$ | async; as vm) {
  <div class="hp-block block1">
    <div class="blue-bean-background parallax"></div>
    <div class="hp-block-inner">
      <div class="hp-title title-l">
        <h1>{{ 'HOME.B1.TITLE' | translate }}</h1>
      </div>
      <p>{{ 'HOME.B1.TEXT' | translate }}</p>
      <div class="hp-call-to-action onboarding-btn">
        <ui-button
          mkpDataTest="register-button"
          routerLink="/onboarding"
          [config]="primaryRegisterButtonConfig"
          [translate]="'HOME.BUTTON.JOBAD'"
        />
      </div>
      <ui-prompt-link
        class="hp-login-hint"
        dataTest="home-login-link"
        link="ONBOARDING.LOGIN"
        prompt="ONBOARDING.ALREADY_HAVE_ACCOUNT"
        route="/passwordless-login"
      />
    </div>
    @if (vm.isMobile === false) {
      <img
        class="candidate-hires img-shadow limited-width"
        alt="jobcloud-candidate-page"
        [src]="'candidate-hires' | replacePicture: homepageImageUrl : vm.language"
      />
    }
  </div>
  @if (vm.isMobile === false) {
    <div class="shadow-separator hide-mobile"></div>
  }
  @if (vm.isMobile === false) {
    <div class="hp-logos">
      <ui-asset
        [set]="'logos'"
        [name]="'js24'"
        [styles]="{ height: '32px', width: 'auto', maxWidth: '67px' }"
      />
      <ui-asset
        [set]="'logos'"
        [name]="'jobup'"
        [styles]="{ height: '28px', width: 'auto', maxWidth: '159px' }"
      />
      <ui-asset
        [set]="'logos'"
        [name]="'jobs'"
        [styles]="{ height: '28px', width: 'auto', maxWidth: '159px' }"
      />
      <ui-asset
        [set]="'logos'"
        [name]="'job-winner'"
        [styles]="{ height: '22px', width: 'auto', maxWidth: '146px' }"
      />
      <ui-asset [set]="'logos'" [name]="'google'" [styles]="{ height: '28px', maxWidth: '86px' }" />
    </div>
  }
  <div class="hp-block block2">
    <div class="hp-block-inner">
      <div class="hp-title title-l">
        <h1 class="fw400" [innerHTML]="'HOME.B4.TITLE1' | translate"></h1>
        <h1 [innerHTML]="'HOME.B4.TITLE2' | translate"></h1>
      </div>
    </div>
    <div class="hp-list">
      <div class="hp-list-item">
        <div class="hp-list-item-logo">
          <div
            class="hide-mobile circle-icon"
            inlineSVG="assets/images/homepage/circle-notification.svg"
          ></div>
          <ng-container *ngTemplateOutlet="mobileLogo" />
        </div>
        <div class="hp-list-item-title">{{ 'HOME.B4.ADV1.TITLE' | translate }}</div>
        <div class="hp-list-item-text body-default">{{ 'HOME.B4.ADV1.TEXT' | translate }}</div>
      </div>
      <div class="hp-list-item">
        <div class="hp-list-item-logo">
          <div
            class="hide-mobile circle-icon"
            inlineSVG="assets/images/homepage/circle-building.svg"
          ></div>
          <ng-container *ngTemplateOutlet="mobileLogo" />
        </div>
        <div class="hp-list-item-title">{{ 'HOME.B4.ADV2.TITLE' | translate }}</div>
        <div class="hp-list-item-text body-default">{{ 'HOME.B4.ADV2.TEXT' | translate }}</div>
      </div>
      <div class="hp-list-item">
        <div class="hp-list-item-logo">
          <div
            class="hide-mobile circle-icon"
            inlineSVG="assets/images/homepage/circle-signal.svg"
          ></div>
          <ng-container *ngTemplateOutlet="mobileLogo" />
        </div>
        <div class="hp-list-item-title">{{ 'HOME.B4.ADV3.TITLE' | translate }}</div>
        <div class="hp-list-item-text body-default">{{ 'HOME.B4.ADV3.TEXT' | translate }}</div>
      </div>
      <div class="hp-list-item">
        <div class="hp-list-item-logo">
          <div
            class="hide-mobile circle-icon"
            inlineSVG="assets/images/homepage/circle-device.svg"
          ></div>
          <ng-container *ngTemplateOutlet="mobileLogo" />
        </div>
        <div class="hp-list-item-title">{{ 'HOME.B4.ADV4.TITLE' | translate }}</div>
        <div class="hp-list-item-text body-default">{{ 'HOME.B4.ADV4.TEXT' | translate }}</div>
      </div>
      <ng-template #mobileLogo>
        <div class="show-mobile" inlineSVG="assets/images/homepage/checkmark_icon.svg"></div>
      </ng-template>
    </div>
    <hr class="hp-hr" />
    <div class="hp-sec">
      <div class="hp-sec-icon">
        <img
          loading="lazy"
          ngSrc="assets/images/homepage/shield-lock.svg"
          height="32"
          width="32"
          alt="jobcloud shield lock"
        />
      </div>
      <div class="hp-sec-text body-default bold">{{ 'HOME.B4.ADV5.TEXT' | translate }}</div>
    </div>
  </div>
  <div class="hp-block block3">
    <div class="hide-mobile hide-tablet"></div>
    <div class="hp-title title-l" id="products">
      <h1 class="fw400" [innerHTML]="'HOME.B3.TITLE1' | translate"></h1>
      <h1 [innerHTML]="'HOME.B3.TITLE2' | translate"></h1>
    </div>
    <mkp-demo-products />
  </div>
  @if (vm.isMobile === false) {
    <div class="hp-block block4">
      <div class="hp-block-inner">
        <div class="hp-title title-l">
          <h1 class="fw400" [innerHTML]="'HOME.B5.TITLE1' | translate"></h1>
          <h1 [innerHTML]="'HOME.B5.TITLE2' | translate"></h1>
        </div>
        <p>{{ 'HOME.B4.TEXT' | translate }}</p>
      </div>
      <div class="hp-img-hold-it-2">
        <mds-tabs [config]="tabsConfig">
          @for (tab of tabs; track tab.index) {
            <mds-tab-item
              [id]="tab.index"
              [title]="tab.title | translate"
              [dataTest]="tab.dataTest"
            >
              <img
                width="900"
                height="561"
                alt="jobcloud homepage image"
                [ngSrc]="tab.imageSrc | replacePicture: homepageImageUrl : vm.language"
              />
            </mds-tab-item>
          }
        </mds-tabs>
      </div>
    </div>
  }
  <div class="hp-block block5">
    <div
      class="contact-logo show-mobile"
      inlineSVG="assets/images/homepage/object-contact.svg"
    ></div>
    <div class="hp-block-inner-row">
      <div class="hp-question">
        <div class="hp-title title-l">
          <h1>{{ 'HOME.B5.TITLE' | translate }}</h1>
        </div>
        <p>{{ 'HOME.B5.TEXT' | translate }}</p>
        <div class="hp-call-to-action">
          <ui-button
            mkpDataTest="contact-us-button"
            [config]="contactUsButtonConfig"
            [translate]="'HOME.BUTTON.CONTACT-US'"
            (click)="openZendesk()"
          />
        </div>
      </div>
      <div class="hide-mobile hp-account-manager">
        <ui-account-manager [showContact]="false" />
      </div>
    </div>
  </div>
}
